// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type SettingsIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from settings.svg
 */
export default function SettingsIcon(props: SettingsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="SettingsIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M3 1c1.312 0 2.427.842 2.835 2.015l.048-.008L6 3h9a1 1 0 0 1 .117 1.993L15 5H6q-.085 0-.166-.014A3 3 0 1 1 3 1m13 11a3 3 0 0 0-5.834-.986A1 1 0 0 0 10 11H1l-.117.007A1 1 0 0 0 1 13h9l.117-.007.048-.008A3.001 3.001 0 0 0 16 12m-4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        />
      </g>
    </svg>
  );
}
